import React from "react";
import Container from "react-bootstrap/Container";
import Navigation from "../components/navigation";

const MainLayout = ({ children, logout }) => {
  return (
    <Container>
      <Navigation logout={logout} />
      <div>{children}</div>
    </Container>
  );
};

export default MainLayout;
